export const ACTIONS = {
  FETCH_RETURNS:'SERVICE_FEEDS__ FETCH_RETURNS',
  FETCH_RETURNS_CSV:'SERVICE_FEEDS__ FETCH_RETURNS_CSV',
  POST_ADD_NEW_RETURN:'SERVICE_FEEDS__ ADD_NEW_RETURN'

};
